import { useEffect, useState } from 'react';

export const useFavicon = (initialFavicon: string) => {
	const [favicon, setFavicon] = useState(initialFavicon);

	useEffect(() => {
		const link = document.querySelector<HTMLLinkElement>('link[rel="icon"][type="image/svg+xml"]');
		if (link) {
			link.href = favicon;
		} else {
			const link = document.createElement('link');
			link.rel = 'icon';
			link.type = 'image/svg+xml';
			link.href = favicon;
			document.head.appendChild(link);
		}
	}, [favicon]);

	return setFavicon;
};
